/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Projects_SectionInputs */



/**
* | output |
* | --- |
* | "Projects" |
*
* @param {Explorer_Thumbnail_Projects_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_projects_section = /** @type {((inputs?: Explorer_Thumbnail_Projects_SectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Projects_SectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projets")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проекты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyectos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजनाओं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projetos")
	return /** @type {LocalizedString} */ ("Projects")
});